import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { DeviceType } from '@/shared/helpers/DeviceDetector';

export type SystemState = {
  preventPopstate: boolean;
  deviceType?: DeviceType | null;
};

const initialState: SystemState = {
  preventPopstate: false,
  deviceType: null,
};

const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    setPreventPopstate(state, action: PayloadAction<boolean>) {
      state.preventPopstate = action.payload;
    },
    setDeviceType(state, action: PayloadAction<DeviceType | null>) {
      state.deviceType = action.payload;
    },
  },
});

export const system = systemSlice.reducer;

export const { setPreventPopstate, setDeviceType } = systemSlice.actions;
